'use client';

import React, { useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface ResponsiveFixedWrapperProps {
  className?: string;
  children?: React.ReactNode;
}

export const ResponsiveFixedWrapper: React.FC<ResponsiveFixedWrapperProps> = ({
  className,
  children,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const handleScroll = () => {
      lastScrollY = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (wrapperRef.current) {
            wrapperRef.current.style.transform = `translateY(${lastScrollY * 0.3}px)`;
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className={twMerge('relative w-full overflow-hidden', className)}>
      <div ref={wrapperRef}>{children}</div>
    </section>
  );
};
